import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ products }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
      {products.map((product) => (
        <div key={product.id} className="transform transition-transform duration-300 hover:scale-105">
          <ProductCard product={product} />
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;